import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit } from '@angular/core';
import { NavigationTableInputDirectiveEvent } from './navigation-table-input-directive-event';

@Directive({
	standalone: true,
	selector: '[appNavigationTableInput]'
})
export class NavigationTableInputDirective implements OnInit {

	// Nom de la colonne associée à l'input
	@Input()
	appNavigationTableInput = '';

	onFlecheAppuyee: EventEmitter<NavigationTableInputDirectiveEvent> = new EventEmitter<NavigationTableInputDirectiveEvent>();

	constructor(public elementRef: ElementRef) {
	}

	ngOnInit(): void {
		// On ajoute un attribut sur l'élément pour pouvoir le retrouver facilement dans la directive NavigationTable
		this.elementRef.nativeElement.setAttribute('navigationTableInput', this.appNavigationTableInput);
	}

	/**
	 * Permet de gérer la navigation au clavier avec les touches fléchées haut et bas lorsqu'une touche est pressée
	 * @param event l'évènement de la touche pressée
	 */
	@HostListener('keydown', ['$event'])
	gererNavigation(event: KeyboardEvent): void {
		if (event.code === 'ArrowDown' || event.code === 'ArrowUp') {
			this.onFlecheAppuyee.emit(new NavigationTableInputDirectiveEvent(this, event.code === 'ArrowDown'));
			event.preventDefault();
			event.stopPropagation();
		}
	}
}
